import React from 'react';
import { motion } from 'framer-motion';
import { Boxes, KeyRound, HardHat, Home, Scale, Check, Phone } from 'lucide-react';
const scenarios = [{
  icon: Boxes,
  title: 'Homeowners',
  text: 'You have junk, debris, or clutter that needs to disappear — fast.'
}, {
  icon: KeyRound,
  title: 'Landlords',
  text: 'You have a trashed unit that needs to be rent-ready yesterday.'
}, {
  icon: HardHat,
  title: 'Contractors',
  text: 'You need the site cleared between phases without losing a day.'
}, {
  icon: Home,
  title: 'Real Estate Agents',
  text: "You're prepping a property for photos, showings, and sale."
}, {
  icon: Scale,
  title: 'Estates & Foreclosures',
  text: "You're handling an estate, eviction, or foreclosure property."
}, {
  icon: Check,
  title: 'Anyone Who\'s Just Done',
  text: "You're done looking at the pile and ready to make one call."
}];
export function WhoFor() {
  return <section className="py-20 lg:py-28 bg-white" data-id="element-586" data-mp="3kw8dttiyi12o">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-587" data-mp="3kx0al7oai4uj">
        <div className="max-w-3xl mb-14" data-id="element-588" data-mp="3fyqfsy6h969g">
          <motion.span initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[11px] tracking-[0.25em] font-bold uppercase text-[#C8102E] block mb-4" data-id="element-589" data-mp="3fzrt79ayu4uc">
            Is This You?
          </motion.span>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-[1.05] mb-5" data-id="element-590" data-mp="7nvoev0vuin5">
            THIS ISN'T FOR EVERYONE —
            <br data-id="element-591" data-mp="qh9987avt8p1" />
            BUT IT MIGHT BE{' '}
            <span className="text-[#C8102E]" data-id="element-592" data-mp="mfe8p50ryzcb">PERFECT FOR YOU</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.08
        }} className="text-lg text-gray-600" data-id="element-593" data-mp="ticfe57jsgb2">
            Jose's is the right call if any of these sound like your situation.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 rounded-2xl overflow-hidden border border-gray-200 mb-12" data-id="element-594" data-mp="188s07iw1xm8p">
          {scenarios.map((scenario, i) => {
          const Icon = scenario.icon;
          return <motion.div key={scenario.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06,
            duration: 0.45,
            ease: [0.23, 1, 0.32, 1]
          }} className="group bg-white hover:bg-[#F9F9F9] p-7 transition-colors" data-id="element-595" data-mp="1m79kt7qnuime" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-596" data-mp="2a4fxz1p4cr2m">
                  <span className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#C8102E]/8 border border-[#C8102E]/15 flex items-center justify-center text-[#C8102E] group-hover:bg-[#C8102E] group-hover:text-white transition-colors" data-id="element-597" data-mp="25ak3wabz7ocq">
                    <Icon size={20} data-id="element-598" data-mp="1wcrnf2uiqanr" />
                  </span>
                  <div data-id="element-599" data-mp="2t1h4ws28h197">
                    <h3 className="font-bold text-[#1A1A1A] mb-1.5" data-id="element-600" data-mp="2szw7muojb47n">
                      {scenario.title}
                    </h3>
                    <p className="text-[15px] text-gray-600 leading-relaxed" data-id="element-601" data-mp="2oxrjgbguuzse">
                      {scenario.text}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center" data-id="element-602" data-mp="18mdrv2cq5tof">
          <p className="text-lg text-gray-700 font-medium" data-id="element-603" data-mp="2rh4e02iew6gs">
            Sound familiar? Get a free estimate in about a minute.
          </p>
          <a href="tel:8312407401" className="inline-flex items-center gap-2 bg-[#1A1A1A] text-white px-6 py-3.5 rounded-xl font-bold hover:bg-[#C8102E] transition-colors" data-id="element-604" data-mp="2ij26r5834hl2">
            <Phone size={18} data-id="element-605" data-mp="3b7zo964h2acr" />
            <span data-id="element-606" data-mp="3b7pv59o4rn2u">(831) 240-7401</span>
          </a>
        </motion.div>
      </div>
    </section>;
}